import styled, { css } from "styled-components";
import { CoreTypography, CoreTooltipIconButton } from "@boi/components-core";
import { useDesignTokens, parseSizeToken } from "@boi/react-design-tokens";

type WrapperProps = {
  $variant: CoreTooltipIconButton.Variant;
  $typographyVariant: CoreTypography.Variant;
};

export const Wrapper = styled.span<WrapperProps>`
  ${({ $variant, $typographyVariant }) => {
    const { tokens } = useDesignTokens();
    const { iconButton, typography, spacing } = tokens;

    return css`
      width: ${iconButton.inner.icon.width[$variant]};
      height: ${parseSizeToken(typography.lineHeight[$typographyVariant])};
      margin-left: ${spacing.s8};
      display: inline-grid;
      align-content: center;
      justify-content: center;
      vertical-align: top;
    `;
  }}
`;
